<template>
  <ReportPage
    :company-id="companyId"
    :type="type"
    :path="path"
  />
</template>

<script>

import ReportPage from '@telexpress_auth/vue-report/dist/components/report.umd.min';

export default {
  components: {
    ReportPage
  },
  data() {
    return {
      companyId: this.$env.VUE_APP_COMPANYID,
      type: 'RPMgmActivityEffect',
      path: ''
    };
  },
  created() {
  }
};
</script>
